<div style="width:100%;background-color:#FFE9E7;z-index:9999 !important;min-height:200px;">

    <div style="margin-top:5px; margin-left:20px;">
        <span  style="height:75px;width:100px;">
            <mat-icon style="color:red; font-size:40px;height:50px;width:50px;">error</mat-icon>
        </span>
    </div>

    <div style="margin-top:0px;position:relative;top:-35px;">
        <span class="d-flex justify-content-center align-items-center">
            <span class="ace-secondary-text-14pt-semi" style="font-size:36px;font-weight: bold !important;color: black;">{{displayErrorMainMessage}}</span>
        </span>
    </div>

    @if(displayErrorSecondaryMessage.length > 0){
        <div style="margin-top:35px;margin-left:15px;margin-right:15px;">
            <span class="d-flex justify-content-left align-items-left">
                <span class="ace-secondary-text-14pt-semi" style="font-size:24px;font-weight: bold !important;color: black;">{{displayErrorSecondaryMessage}}</span>
            </span>
        </div>
    }

    @if(displayErrorNumber.length > 0){
        <div style="margin-top:35px;margin-left:15px;margin-right:15px;">
            <span class="d-flex justify-content-left align-items-left">
            <span class="ace-secondary-text-14pt-semi" style="font-size:24px;font-weight: bold !important;color: black;">{{displayErrorNumber}}</span>
              <button mat-icon-button aria-label="Copy Parker Name" [cdkCopyToClipboard]="errMessageCopyData"  
                    matTooltip="Copy Error Message" (click)="onCopyMessage('Error Information copied to clipboard')"
                    style="position:relative;top:-15px;"
                    >
                    <mat-icon style="color:black;">content_copy</mat-icon>
                </button>&nbsp;&nbsp;&nbsp;
            </span>
        </div>
    }

    <div style="margin-top:25px;margin-bottom:5px;">
        <span class="d-flex justify-content-center align-items-center">
            <span class="ace-secondary-text-14pt-semi" style="font-size:21px;font-weight: bold !important;color: black;">
                    If this issue persists, contact the spACE-AR Administrator at spaceAR&#64;aceparking.com.
            </span>
        </span>
    </div>

    <div style="margin-bottom:5px;">
        <span class="d-flex justify-content-center align-items-center">
        <p><button mat-button mat-dialog-close cdkFocusInitial style="background-color:#002F87;color:white;">Close</button></p>
        </span>
    </div>
</div>
